<template>
  <div class="spec-list">
    <div class="spec-item" v-for="(item, index) in sampleList" :key="index">
      <el-form label-position="top" class="spec-form" :model="item" :rules="sampleRules" :ref="'sample' + index" :class="{'no-border': index === sampleList.length - 1}">
        <div class="spec-title">{{item.sampleName}} {{item.row}}#</div>
        <el-row :gutter="41">
          <el-col :span="8">
            <el-form-item :label="reportLuaCodeType === 2 ? '样品名称/Sample Name' : '样品名称'" class="is-required application" prop="sampleNameCn">
              <el-input :placeholder="reportLuaCodeType === 2 ? 'Please type in English' : ''" v-model="item.sampleNameCn" :disabled="applicationDiabled || disabledAll" maxlength="400"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8" v-if="reportLuaCodeType === 3" >
            <el-form-item label="Sample Name" prop="sampleNameEn" class="is-required application">
              <el-input placeholder="Please type in English" v-model="item.sampleNameEn" :disabled="applicationDiabled || disabledAll" maxlength="400"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="41" v-if="!item.isExpand">
          <el-col :span="8" v-for="item2 in item.sampleFromDTOList" :key="item2.sampleKey">
            <el-form-item :label="item2.sampleKeyName">
              <el-input placeholder="" v-model="item2.sampleValue" :disabled="applicationDiabled || disabledAll" maxlength="400"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <span class="expand-btn" @click="changeSpecExpand(item)">
                  <img :src="!item.isExpand ? closeIcon : expandIcon" alt="">
                  {{item.isExpand ? '展开' : '收起'}}
                </span>
      </el-form>
    </div>
  </div>
</template>

<script>
import expandIcon from '../../assets/images/spec-expand.png'
import closeIcon from '../../assets/images/spec-close.png'
export default {
  name: 'TicSample',
  props: {
    requiredValidate: {
      type: Object,
      default() {
        return { trigger: 'change', required: true, message: '必填项' }
      }
    },
    reportLuaCodeType: {
      type: Number,
      default: 3
    },
    applicationDiabled: {
      type: Boolean,
      default: false
    },
    disabledAll: {
      type: Boolean,
      default: false
    },
    list: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      sampleList: [],
      sampleRules: {
        sampleNameCn: [this.requiredValidate],
        sampleNameEn:[this.requiredValidate]
      },
      expandIcon,
      closeIcon
    }
  },
  watch: {
    list: {
      handler(val) {
        console.log(val);
        this.sampleList = JSON.parse(JSON.stringify(val))
      },
      immediate: true
    }
  },
  methods: {
    changeSpecExpand(data) {
      this.$set(data, 'isExpand', !data.isExpand)
    },
    validateForm(key, isArr) {
      if (isArr) {
        return new Promise(resolve => this.$refs[key][0].validate(resolve))
      }
      return new Promise(resolve => this.$refs[key].validate(resolve))
    },
    getValidate() {
      const arr = []
      this.sampleList && this.sampleList.forEach((v, index) => {
        const key = 'sample' + index
        arr.push(this.validateForm(key, true))
      })
      return arr
    },
    getSample() {
      return JSON.parse(JSON.stringify(this.sampleList))
    }
  }
};
</script>

<style scoped lang="scss">
  .invoice-person {
    .el-col {
      display: flex;
      .label {
        margin-right: 20px;
        flex-shrink: 0;
      }
    }
  }
  .yangpin-tab {
    height: 22px;
    background: #F6F6F6;
    border: 1px solid #DCDCDC;
    border-radius: 3px;
    font-size: 14px;
    font-family: Arial;
    font-weight: 400;
    color: #878787;
    text-align: center;
    line-height: 20px;
    max-width: 202px;
    padding: 0 3px;
    white-space:nowrap;/* 规定文本是否折行 */
    overflow: hidden;/* 规定超出内容宽度的元素隐藏 */
    text-overflow: ellipsis;
    &:not(:first-child) {
      margin-left: 5px;
    }
  }
  .no-report {
    padding: 55px 0 64px;
    display: flex;
    align-items: center;
    .no-report-tips {
      margin-left: 25px;
      font-size: 16px;
      color: #878787;
      line-height: 1;
    }
  }
  .order-detail-content {
    padding-bottom: 40px;
    .order-info {
      background: #fff;
      padding: 30px 33px 20px 33px;
      .order-info-title {
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #333333;
        line-height: 1;
        margin-bottom: 18px;
      }
      .order-info-no-time {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #878787;
        line-height: 14px;
        height: 22px;
        border-bottom: 1px solid #D2D2D2;
      }
      .order-info-content{
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        padding:20px 0;
        .order-info-content-left{
          flex:1;
          display: flex;
          flex-direction: column;
          .order-info-content-left-top{
            display: flex;
            flex-direction: row;
            div{
              margin-right: 20px;
            }
          }
        }
        .order-info-content-right{
          width: 300px;
          display: flex;
          flex-direction: row;
          flex-wrap: wrap;
          div{
            width: 150px;
          }
        }
      }
    }

    .order-info-other {
      /*display: flex;*/
      margin-top: 22px;
      line-height: 2;
      word-break: break-all;
      .order_info_title{
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #878787;
        line-height: 20px;
      }
      .order-info-item {
        margin-right: 15px;
        &:before {
          content: "";
          display: inline-block;
          width: 6px;
          height: 6px;
          background: #ca4300;
          /*margin-top: 4px;*/
          margin-right: 5px;
          position: relative;
          top: -2px;
        }
      }
      .label, .info {
        font-size: 14px;
        font-weight: 400;
        color: #878787;
        /*line-height: 14px;*/
      }
      .info {
        color: #333333;
      }
    }
    .order_info_price{
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      .price_left{
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
      }
      .price_right p span{
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
      }
    }
    .price_download{
      text-align: center;
      margin-bottom: 20px;
    }
    .price_download span{
      width: 140px;
      height: 36px;
      background: #CA4300;
      border-radius: 3px;
      display: inline-block;
      line-height: 36px;
      text-align: center;
      color: #ffffff;
      cursor: pointer;
    }
    .modify-list {
      background: #fff;
      margin-top: 19px;
      padding: 25px 33px;
      .modify-list-title {
        line-height: 1;
        margin-bottom: 18px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        .modify-list-title_a{
          font-size: 16px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #333333;
        }
        .modify-list-title_b{
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #878787;
          cursor:pointer;
          span{
            vertical-align: middle;
          }
        }
      }
    }
    .process-light {
      margin-bottom: 19px;
      height: 125px;
      background: #FFFFFF;
      padding-top: 19px;
      position: relative;
      .process-light-title {
        position: absolute;
        top: 25px;
        left: 34px;
        font-size: 16px;
        font-weight: bold;
        color: #333333;
        line-height: 1;
      }
    }
    .operate-area {
      background: #fff;
      margin-top: 20px;
      display: flex;
      flex-direction: row;
      .operate_left{
        width:140px;
        margin-right: 20px;
      }
      .spec-area {
        width:1066px;
        padding-right:20px;
        padding-top:10px;
        position: relative;

        .spec-area—tit{
          width: 100%;
          border-bottom: 1px solid #D2D2D2;
          padding: 10px 0;
          margin-bottom: 16px;
          height: 40px;
          .spec-area—tit-left{
            font-size: 16px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #333333;
            float: left;
          }
          .spec-area—tit-right{
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #333333;
            float: right;
          }
        }
        .disabled-div {
          position: absolute;
          top: 0;
          width: 1066px;
          height: 100%;
          z-index: 999;
          left: 0;
        }
        .separate-tips {
          font-size: 16px;
          font-weight: bold;
          color: #FF0000;
          line-height: 1;
          text-align: center;
          margin-top: 31.5px;
          height: 1px;
          background: #D2D2D2;
          position: relative;
          span {
            padding: 0 10px;
            background: #fff;
            position: absolute;
            left: 466px;
            top: -7.5px;
          }
        }
      }
      .contact-us {
        font-size: 16px;
        color: #FE6601;
        line-height: 1;
        position: absolute;
        top: 20px;
        right: 33px;
        cursor: pointer;
        img {
          vertical-align: bottom;
        }
      }
      .el-menu.el-menu--vertical {
        border-bottom: 3px solid #DBDBDB;
        height: 37px;
      }
      .el-menu--vertical > .el-menu-item,  .el-menu--vertical > .el-menu-item:hover {
        width: 140px;
        height: 48px;
        background: linear-gradient(90deg, #E3E3E3, #F6F6F6);
        border-radius: 8px 8px 0px 0px;
        line-height: 34px;
        color: #333333;
        font-size: 16px;
        font-weight: bold;
        text-align: center;
        border-bottom: 3px solid #DBDBDB!important;
      }
      .el-menu--vertical > .el-menu-item.is-active, .el-menu--vertical > .el-menu-item.is-active:hover {
        border-bottom: 3px solid #ca4300 !important;
        color: #FFFEFE;
        background: #ca4300;
        transition: all 1.5s linear 0s;
      }
      .el-menu--vertical > .el-menu-item {
        position: absolute;
        bottom: -3px;
        &:nth-child(1) {
          left: 0;
          z-index: 4;
        }
        &:nth-child(2) {
          left: 126px;
          z-index: 3;
        }
        &:nth-child(3) {
          left: 252px;
          z-index: 2;
        }
        &:nth-child(4) {
          left: 378px;
          z-index: 1;
        }
        &:nth-child(5) {
          left: 504px;
          z-index: 1;
        }
        &.is-active {
          z-index: 5;
        }
      }
      .operate-module {
        border-bottom: 1px solid #D2D2D2;
        margin-bottom: 25px;
        padding-bottom: 25px;
      }
      .module_user{
        position: relative;
        .module_checkout{
          position: absolute;
          top: -4px;
          left: 125px;
          .tit{
            font-size: 12px;
            font-family: "Microsoft YaHei";
            font-weight: 400;
            color: #ca4300;
            margin-left: 10px;
            border: 1px solid #ca4300;
            padding: 2px;
            border-radius: 5px;
            cursor: pointer;
          }
        }
      }
      .print_box{
        margin-top: 20px;
      }
      .operate-title {
        font-size: 16px;
        font-weight: bold;
        color: #333333;
        line-height: 16px;
        margin-bottom: 25px;
        &:before {
          content: "";
          display: inline-block;
          width: 3px;
          height: 16px;
          background: #ca4300;
          margin-right: 13px;
          vertical-align: bottom;
        }
        .tit{
          font-size: 12px;
          font-family: "Microsoft YaHei";
          font-weight: 400;
          color: rgb(202, 67, 0);
          margin-left: 10px;
          border: 1px solid #ca4300;
          padding: 2px;
          border-radius: 5px;
          cursor: pointer;
        }
      }
      .operate-tips-text{
        font-size: 14px;
        color: #000000;
        line-height: 16px;
        margin-bottom: 16px;
        img {
          vertical-align: bottom;
          margin-right: 5px;
        }
      }
      .operate-tips {
        font-size: 14px;
        font-weight: bold;
        color: #FF0000;
        line-height: 16px;
        margin-bottom: 16px;
        img {
          vertical-align: bottom;
          margin-right: 5px;
        }
      }
      .invoice-btn {
        font-size: 14px;
        font-weight: 400;
        color: #333333;
        line-height: 42px;
        width: 220px;
        height: 44px;
        border: 1px dashed #A0A0A0;
        opacity: 0.8;
        border-radius: 5px;
        text-align: center;
        cursor: pointer;
      }
      .spec-order-info {
        font-size: 14px;
        font-weight: 400;
        color: #333333;
        line-height: 14px;
        margin: 21px 0 15px 0;
        text-align: center;
      }
      .spec-tips {
        font-size: 14px;
        font-weight: 400;
        color: #878787;
        line-height: 22px;
      }
      .spec-title {
        font-size: 14px;
        font-weight: bold;
        color: #333333;
        line-height: 14px;
        margin-bottom: 10px;
        word-break: break-all;
      }
      .expand-btn {
        font-size: 14px;
        color: #878787;
        line-height: 18px;
        margin-bottom: 10px;
        cursor: pointer;
        img {
          vertical-align: bottom;
        }
      }
      .spec-param {
        font-size: 14px;
        color: #333333;
        line-height: 30px;
        display: flex;
      }
      .spec-label {
        margin-right: 20px;
      }
      .spec-param-content {
        font-size: 14px;
        color: #333333;
        line-height: 30px;
        display: flex;
        flex-wrap: wrap;
      }
      .add-email-btn {
        width: 54px;
        height: 30px;
        border: 1px dashed #A0A0A0;
        opacity: 0.8;
        border-radius: 5px;
        text-align: center;
        font-size: 14px;
        color: #333333;
        cursor: pointer;
        margin-bottom: 5px;
      }
      .address-content {
        display: flex;
        .address-label {
          width: 220px;
          height: 42px;
          background: #FFFFFF;
          border: 2px solid #ca4300;
          text-align: center;
          white-space: nowrap; /* 规定文本是否折行 */
          overflow: hidden; /* 规定超出内容宽度的元素隐藏 */
          text-overflow: ellipsis;
          padding: 0 20px;
          line-height: 38px;
          font-size: 14px;
          color: #333333;
          position: relative;
          margin-right: 36px;
          flex-shrink: 0;

          img {
            position: absolute;
            bottom: 0;
            right: 0;
          }
        }

        .address-detail {
          font-size: 14px;
          color: #333333;
          line-height: 21px;
        }

        .edit-address-btn {
          margin-left: 10px;
          color: #fff;
          cursor: pointer;
          display: inline-block;
          width: 39px;
          height: 22px;
          background: #ca4300;
          border-radius: 4px;
          text-align: center;
        }
      }
      .address-btn {
        color: #878787;
        width: 120px;
        height: 30px;
        border: 1px dashed #B5B5B5;
        border-radius: 5px;
        text-align: center;
        line-height: 28px;
        cursor: pointer;
      }
      .operate-btns {
        text-align: center;
        margin-top: 54px;
      }
      .operate-save-btn {
        width: 177px;
        height: 44px;
        border: 1px solid #ca4300;
        color: #ca4300;
        font-weight: bold;
        font-size: 16px;
        border-radius: 0;
        margin-right: 27px;
      }
      .operate-submit-btn {
        width: 177px;
        height: 44px;
        font-weight: bold;
        font-size: 16px;
        border-radius: 0;
      }
      .add-email-input {
        position: relative;
        margin-bottom: 5px;
        .err-msg {
          color: red;
          line-height: 1;
          font-size: 12px;
        }
      }
      .report-email-item {
        height: 30px;
        background: #EBEBEB;
        border-radius: 5px;
        border: none;
        padding: 0 10px;
        font-size: 14px;
        color: #333333;
        line-height: 30px;
        margin-right: 16px;
        margin-bottom: 5px;
        img {
          vertical-align: middle;
          margin-left: 10px;
          cursor: pointer;
        }
      }
      .invoice-content {
        &.need-address {
          border-bottom: 1px dashed #A0A0A0;
          margin-bottom: 17px;
          .invoice-item:last-child {
            margin-bottom: 20px;
          }
        }
      }
      .invoice-item {
        font-size: 14px;
        color: #333333;
        line-height: 1;
        margin-bottom: 20px;
        display: flex;
        &:last-child {
          margin-bottom: 0;
        }
        .label {
          margin-right: 79px;
          display: inline-block;
          width: 56px;
        }
        .detail {
          flex: 1;
        }
        .edit-btn {
          color: #fff;
          cursor: pointer;
          display: inline-block;
          width: 39px;
          height: 22px;
          background: #ca4300;
          border-radius: 4px;
          text-align: center;
          line-height: 22px;
          margin-left: 10px;
        }
      }
      .yangpinyaoqiu {
        font-size: 14px;
        color: #333333;
        line-height: 1;
      }
      .print-application {
        width: 168px;
        height: 42px;
        border-radius: 0;
        margin-top: 20px;
      }
      .wuliu-money {
        width: 500px;
        font-size: 14px;
        color: #333333;
        line-height: 42px;
        .el-button {
          width: 140px;
          height: 42px;
          border-radius: 3px;
        }
      }
      .report-content {
        padding-top: 29px;
        .report-list-tips {
          font-size: 14px;
          font-weight: 400;
          color: #333333;
          line-height: 1px;
          margin-bottom: 40px;
        }
        .download-report-btn {
          color: #ca4300;
          cursor: pointer;
          text-decoration: underline;
          &:hover {
            color: red;
          }
        }
        .report-item {
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #ca4300;
          line-height: 14px;
          margin-bottom: 30px;
          .file {
            cursor: pointer;
          }
          &:hover {
            color: red;
          }
          &:last-child {
            margin-bottom: 0;
          }
          .icon {
            content: '';
            display: inline-block;
            width: 5px;
            height: 5px;
            background: #535353;
            border-radius: 50%;
            margin-right: 13px;
            position: relative;
            top: -3px;
          }
        }
      }
      .pay_tit_list{
        height: 36px;
        background: #F5F5F5;
        border: 1px solid #E9E9E9;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 24px 0 17px;
        .pay_tit_list_lf{
          display: flex;
          div{
            margin-right: 15px;
          }
          .lf_tab{
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #878787;
            line-height: 36px;
          }
          .lf_tit1{
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #333333 ;
            line-height: 36px;
          }
          .lf_tit2{
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: #333333 ;
            line-height: 36px;
          }
          .lf_tit3{
            font-size: 14px;
            font-family: Microsoft YaHei;
            color: #CA4300 ;
            line-height: 36px;
            font-weight: bold;
          }
          .lf_repair{
            width: 14px;
            height: 14px;
            background: #CA4300;
            border-radius: 3px;
            font-size: 11px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: #FFFFFF;
          }

        }
        .pay_tit_list_rg{
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #878787;
          display: flex;
          cursor: pointer;
          .rg_icon img{
            width: 18px;
            height: 18px;
            margin-right: 5px;
          }
        }
      }
      .pay-list {
        padding-top: 20px;
        padding-left: 17px;
        .pay-item {
          font-size: 14px;
          font-weight: 400;
          color: #333333;
          margin-bottom: 20px;
        }
        .img-list {
          display: flex;
          flex-wrap: wrap;
          .img-item {
            width: 182px;
            text-align: center;
            margin-right: 40px;
            cursor: pointer;
          }
          .file-img {
            width: 182px;
            height: 105px;
            margin: 10px 0 15px;
            text-align: center;
            padding-top: 20.5px;
            img {
              width: auto;
              height: auto;
              margin: 0;
            }
          }
          img {
            width: 182px;
            height: 105px;
            margin: 10px 0 15px;
          }
        }
      }
    }
  }
  .sf-tips {
    font-size: 14px;
    color: #878787;
    line-height: 16px;
    margin-left: 10px;
    a {
      color: #ca4300;
      text-decoration: underline;
    }
    .sf-tips-icon {
      display: inline-block;
      width: 16px;
      height: 16px;
      background: #FF0000;
      border-radius: 50%;
      font-size: 13px;
      font-weight: bold;
      color: #FFFFFF;
      padding-left: 5px;
      vertical-align: bottom;
    }
  }
</style>
